// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"aae13b9b","88":"069f28b7","153":"13acc2f3","278":"472c2fbc","704":"9fe64c79","755":"769f8547","774":"2c7e33a5","868":"a10381e9","941":"38bbaf21"}[chunkId] + ".chunk.js";
};